// components/ResponsiveStack.tsx
"use client";
import { HStack, VStack, Show } from "@chakra-ui/react";

const ResponsiveStack = ({ children, ...props }: any) => {
  return (
    <>
      {/* Mobile, < 768px */}
      <Show below="md-1">
        <VStack {...props}>{children}</VStack>
      </Show>
      {/* Desktop, >= 768px */}
      <Show above="md">
        <HStack {...props}>{children}</HStack>
      </Show>
    </>
  );
};

export default ResponsiveStack;
